import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { AmendmentSearchProvider } from './context/amendment-search-context';
import { AmendmentSearchComponent } from './amendment-search-component';

export function AmendmentSearchFactory() {
    return (
        <BaseLayoutFactory>
            <AmendmentSearchProvider>
                <AmendmentSearchComponent />
            </AmendmentSearchProvider>
        </BaseLayoutFactory>
    );
}
